import { lit } from '../../utils/literal.js';

/**
 * 工作台可配置项目
 *
 * @public
 */
const WorkbenchConfigurationState = {
    // toolbar
    DisableToolbar: lit('toolbar.disabled'),
    ToolbarAlignment: lit('toolbar.alignment'),
    ToolbarTopOffset: lit('toolbar.topOffset'),
    ToolbarFixedKeys: lit('toolbar.fixedKeys'),
    ToolbarPinnedKey: lit('toolbar.pinnedKey'),
    ToolbarSchemaAnimation: lit('toolbar.schemaAnimation'),
    ToolbarGridChunkSize: lit('toolbar.gridChunkSize'),
    ToolbarPanelHeight: lit('toolbar.panelHeight'),
    ToolbarPopupPanelMaxHeight: lit('toolbar.popupPanelMaxHeight'),
    ToolbarRespectSoftKeyboard: lit('toolbar.respectSoftKeyboard'),
    ToolbarButtonActiveStyle: lit('toolbar.buttonActiveStyle'),
    ToolbarButtonTooltipPlacement: lit('toolbar.buttonTooltipPlacement'),
    // statusbar
    DisableStatusbar: lit('statusbar.disabled'),
    // contextMenu
    DisableContextMenu: lit('contextMenu.disabled'),
    MultiRowsContextMenu: lit('contextMenu.multiRows'),
    ContextMenuShouldHideBeforeShow: lit('contextMenu.shouldHideMenuBeforeShow'),
    // titlebar
    DisableTitlebar: lit('titlebar.disabled'),
    TitlebarHeight: lit('titlebar.height'),
    TitlebarHoverable: lit('titlebar.hoverable'),
    TitlebarContentDefaultStyle: lit('titlebar.contentDefaultStyle'),
    // drawer
    DisableDrawer: lit('drawer.disabled'),
    // editorZone
    PaddingLeft: lit('editorZone.paddingLeft'),
    PaddingRight: lit('editorZone.paddingRight'),
    PaddingTop: lit('editorZone.paddingTop'),
    PaddingBottom: lit('editorZone.paddingBottom'),
    SupportNativeDomScrolling: lit('editorZone.supportNativeDomScrolling'),
    Namespace: lit('namespace'),
    DebugMode: lit('debugMode'),
    SelectionThrottleTime: lit('selectionThrottleTime'),
    ModelThrottleTime: lit('modelThrottleTime'),
    AccessibilityDropdownAutoFocus: lit('accessibility.dropdownAutoFocus'),
    AccessibilityMenuClickFocus: lit('accessibility.menuClickFocus'),
};
const WorkbenchMountSettings = {
    Controllers: lit('controllers'),
    Features: lit('features'),
    Services: lit('services'),
};

export { WorkbenchConfigurationState, WorkbenchMountSettings };
//# sourceMappingURL=auto-sync-settings.js.map
